// src/services/export.service.js
import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";
import { getReduxValue } from "../utils/redux.js";

export const startExport = async (
  animationId,
  {
    exportType = "video",
    quality = "1080p",
    layout = "landscape",
    startTime = 0,
    endTime,
    time = 0,
    frame,
  } = {},
) => {
  const result = await request(getEndpoint("studio", "startExport", animationId), {
    body: { exportType, quality, layout, startTime, endTime, time, frame },
  });
  return result.data; // { jobId }
};

export const getExportStatus = async (jobId) => {
  const result = await request(getEndpoint("studio", "getExportStatus", jobId));
  return result.data; // { jobId, status, progress, error }
};

// Can't use request() here — response is binary MP4, not JSON
export const downloadExport = async (
  jobId,
  animationTitle = "animation",
  {
    exportType = "video",
    quality = "1080p",
    layout = "landscape",
    startTime = 0,
    endTime = 0,
    time = 0,
  } = {},
) => {
  const accessToken = getReduxValue("auth.accessToken");
  const BASE_URL = import.meta.env.VITE_API_BASE_URL;

  const res = await fetch(`${BASE_URL}/export/download/${jobId}`, {
    credentials: "include",
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || "Download failed");
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const extension = exportType === "image" ? "png" : "mp4";
  const rangePart =
    exportType === "image"
      ? Math.round(time * 1000)
      : `${Math.round(startTime * 1000)}_${Math.round(endTime * 1000)}`;
  a.download = `${animationTitle}_${exportType}_${quality}_${layout}_${rangePart}_${Date.now()}.${extension}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
